"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.498 4.707a3.38 3.38 0 0 1 3.378 3.377V17.3a3.7 3.7 0 0 1-3.7 3.7H8.825a3.7 3.7 0 0 1-3.7-3.7V8.084a3.36 3.36 0 0 1 3.382-3.36l-.01 1.4a1.96 1.96 0 0 0-1.972 1.96V17.3a2.3 2.3 0 0 0 2.3 2.3h6.35a2.3 2.3 0 0 0 2.3-2.3V8.084a1.98 1.98 0 0 0-1.977-1.977z",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.348 5.676A2.676 2.676 0 0 1 10.024 3h3.952a2.676 2.676 0 0 1 0 5.352h-3.952a2.676 2.676 0 0 1-2.676-2.676M10.024 4.4a1.276 1.276 0 0 0 0 2.552h3.952a1.276 1.276 0 0 0 0-2.552z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PasteIcon24.js.map